import type { InferInsertModel, InferSelectModel } from 'drizzle-orm';
import { relations } from 'drizzle-orm';
import { boolean, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';
import { softDelete } from '../columns/soft-delete';
import { setlistSongs } from './setlist-songs';
import { users } from './users';

export const setlists = pgTable('setlists', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  name: text('name').notNull(),
  scheduledAt: timestamp('scheduled_at', { mode: 'string' }),
  userId: uuid('user_id')
    .references(() => users.id)
    .notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
  ...softDelete,
});

export const setlistsRelations = relations(setlists, ({ one, many }) => ({
  items: many(setlistSongs),
  user: one(users, {
    fields: [setlists.userId],
    references: [users.id],
  }),
}));

export type Setlist = InferSelectModel<typeof setlists>;
export type CreateSetlistInput = InferInsertModel<typeof setlists>;
export type UpdateSetlistInput = Partial<CreateSetlistInput>;
